var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{style:({'overflow-y': 'hidden'}),attrs:{"max-height":_vm.maxHeight,"min-height":_vm.minHeight,"max-width":_vm.width,"min-width":_vm.width}},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_vm._t("title")],2),_c('v-card',{style:({
      'overflow-y': !_vm.overflowOff?'auto': ''
    }),attrs:{"flat":"","max-height":_vm.containerHeight,"color":_vm.isMobile? 'transparent':''}},[_vm._t("default")],2),_vm._t("buttons")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }